function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import useLever from './useLever';

export default function Lever(props) {
  var children = props.children,
      feature = props.feature,
      options = _objectWithoutProperties(props, ['children', 'feature']);

  var isEnabled = useLever(feature, options);
  if (isEnabled) return children;
  return null;
}